/* eslint-disable import/prefer-default-export */
export const GET_DEDICATED_CUSTOMERS = 'GET_DEDICATED_CUSTOMERS';
export const SEARCH_DEDICATED_CUSTOMERS = 'SEARCH_DEDICATED_CUSTOMERS';
